var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useQuery } from "react-query";
import { useAuthContext } from "context/AuthContext";
import { getAcctOverview, getAccountCount, getAllEmailCampaignRevenue, getCampaignRevenue, getEmailMetrics, getInterfacePie, getPerformancePie, getSenderPie, getStatusTrendGraph, getSummaryPanel, getSummaryRevenue, getSummaryRevenueForVoice, getTemplateDistribution, getUsersCount, getVolumetricsPanel, getWAATemplateAnalyticsApi, getWASummaryPanel, getWhatsAppRevenueTrend, getWhatsAppStatusTrend, getWhatsAppTemplateTypes, getWhatsAppTotalRevenue, getSummarySmsRevenueData, getAgentsOverviewForRCS, getEmailVolPanelData, getAllRcsCampaignRevenue, getWAABusinessNumCounter, getAllRcsMessageType, getAllRcsScheduledCampaign, getAllRcsTotalRevenue, getAllRcsPostbackData, getWaRevenueByMonth, getSmsRevenueByMonth, getEmailRevenueByMonth, getRcsRevenueByMonth, getAllRcsSummarypanel, } from "lib/dashboard-apis";
var _options = {
    staleTime: 5 * 60 * 1000,
    retry: 1,
    retryDelay: 2 * 1000,
    refetchOnWindowFocus: false,
};
// Generic reusable hoo
var useDashboardQuery = function (key, apiFn, _a) {
    var _b = _a.qKeys, qKeys = _b === void 0 ? [] : _b, _c = _a.options, options = _c === void 0 ? {} : _c;
    var userDetails = useAuthContext().userDetails;
    return useQuery(__spreadArray([key, userDetails === null || userDetails === void 0 ? void 0 : userDetails.token], qKeys, true), apiFn, __assign(__assign({}, _options), options));
};
/**
 * Common args for all dashboard hooks
 *
 * @typedef {Object} DashboardHookArgs
 * @property {Array} [qKeys]   - Extra query keys to differentiate cache
 * @property {Object} [options] - Extra react-query options
 */
// Thin wrappers
export var useAcctOverview = function (arg) {
    return useDashboardQuery("accountOverview", getAcctOverview, arg);
};
/**
 * Hook to get volumetrics panel
 * @param {DashboardHookArgs} arg
 */
export var useVolumetricsPanel = function (arg) {
    return useDashboardQuery("volumetricsPanel", getVolumetricsPanel, arg);
};
export var useRCSSummaryPanel = function (arg) {
    return useDashboardQuery("volumetricsPanel", getAllRcsSummarypanel, arg);
};
/**
 * Hook to get campaign revenue
 * @param {DashboardHookArgs} arg
 */
export var useCampaignRevenue = function (arg) {
    return useDashboardQuery("revenueData", getCampaignRevenue, arg);
};
export var useScheduleCampaignData = function (arg) {
    return useDashboardQuery("scheduleCampaignData", getAllRcsScheduledCampaign, arg);
};
export var useRCSTotalRevenue = function (arg) {
    return useDashboardQuery("totalRevenueData", getAllRcsTotalRevenue, arg);
};
export var usePostbackData = function (arg) {
    return useDashboardQuery("postbackData", getAllRcsPostbackData, arg);
};
export var useStatTrendData = function (arg) {
    return useDashboardQuery("statTrendData", getStatusTrendGraph, arg);
};
export var useSummarySmsRevenueData = function (arg) {
    return useDashboardQuery("SummarySmsRevenueData", getSummarySmsRevenueData, arg);
};
export var useAgentsOverviewForRCS = function (arg) {
    return useDashboardQuery("agentsOverviewForRcs", getAgentsOverviewForRCS, arg);
};
/**
 * Hook to get accounts count
 * @param {DashboardHookArgs} arg
 */
export var useAccountsCountData = function (arg) {
    return useDashboardQuery("accountsCount", getAccountCount, arg);
};
/**
 * Hook to get users count
 * @param {DashboardHookArgs} arg
 */
export var useUsersCount = function (arg) {
    return useDashboardQuery("usersCount", getUsersCount, arg);
};
/**
 * Hook to get all channel summary panel
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelSummaryPanelData = function (arg) {
    return useDashboardQuery("summaryPanel", getSummaryPanel, arg);
};
export var useEmailVolPanelData = function (arg) {
    return useDashboardQuery("getEmailVolPanelData", getEmailVolPanelData, arg);
};
/**
 * Hook to get whatsapp total revenue
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelWaRevenueData = function (arg) {
    return useDashboardQuery("getWhatsAppTotalRevenue", getWhatsAppTotalRevenue, arg);
};
/**
 * Hook to get Whatsapp summary panel
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelWaSummaryPanelData = function (arg) {
    return useDashboardQuery("waSummaryPanel", getWASummaryPanel, arg);
};
export var useAllChannelRcsSummaryPanel = function (arg) {
    return useDashboardQuery("getAllRcsSummarypanel", getAllRcsSummarypanel, arg);
};
export var useAllChannelRcsCampaignRevenue = function (arg) {
    return useDashboardQuery("getAllRcsCampaignRevenue", getAllRcsTotalRevenue, arg);
};
// useDashboardQuery("getAllRcsCampaignRevenue", getAllRcsCampaignRevenue, arg);
/**
 * Hook to get senders pie chart data
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelSenderPieData = function (arg) {
    return useDashboardQuery("getSenderPie", getSenderPie, arg);
};
/**
 * Hook to get interface pie chart data
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelInterFacePieData = function (arg) {
    return useDashboardQuery("interfacePie", getInterfacePie, arg);
};
/**
 * Hook to get performance pie chart data
 * @param {DashboardHookArgs} arg
 */
export var usePerformancePieData = function (arg) {
    return useDashboardQuery("performancePie", getPerformancePie, arg);
};
/**
 * Hook to get summary revenue
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelSummaryRevenueData = function (arg) {
    return useDashboardQuery("getSummaryRevenue", getSummaryRevenue, arg);
};
/**
 * Hook to get email revenue
 * @param {DashboardHookArgs} arg
 */
export var useEmailCampRevenueData = function (arg) {
    return useDashboardQuery("emailrevenueData", getAllEmailCampaignRevenue, arg);
};
/**
 * Hook to get voice summary revenue
 * @param {DashboardHookArgs} arg
 */
export var useAllChannelSummaryRevenueVoiceData = function (arg) {
    return useDashboardQuery("getSummaryRevenueForVoice", getSummaryRevenueForVoice, arg);
};
/**
 * Hook to get dashboard status trend
 * @param {DashboardHookArgs} arg
 */
export var useStatusTrendData = function (arg) {
    return useDashboardQuery("getStatusTrend", getStatusTrendGraph, arg);
};
export var useRevenueByMonth = function (arg, channel) {
    var _a, _b;
    // const WA_CHANNEL = "whatsapp";
    // const SMS_CHANNEL = "sms";
    // const RCS_CHANNEL = "rcs";
    // const EMAIL_CHANNEL = "email";
    // const ch = channel?.toLowerCase();
    var log = function (x) {
        var y = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            y[_i - 1] = arguments[_i];
        }
        return console.log.apply(console, __spreadArray(["useRevenueByMonth:-".concat(x)], y, false));
    };
    // if (ch === WA_CHANNEL) {
    //   log("WhatsApp");
    //   return useDashboardQuery("getWaRevenueByMonth", getWaRevenueByMonth, arg);
    // } else if (ch === SMS_CHANNEL) {
    //   log("SMS");
    //   return useDashboardQuery("getSmsRevenueByMonth", getSmsRevenueByMonth, arg);
    // } else if (ch === RCS_CHANNEL) {
    //   log("RCS");
    //   return useDashboardQuery("rcsRevenueByMonth", getRcsRevenueByMonth, arg);
    // } else if (ch === EMAIL_CHANNEL) {
    //   log("Email");
    //   return useDashboardQuery("eRevenueByMonth", getEmailRevenueByMonth, arg);
    // } 
    // log(`Unknown Channel: ${channel}`);
    var ch = channel === null || channel === void 0 ? void 0 : channel.toLowerCase();
    var config = {
        whatsapp: {
            key: "getWaRevenueByMonth",
            fn: getWaRevenueByMonth,
        },
        sms: {
            key: "getSmsRevenueByMonth",
            fn: getSmsRevenueByMonth,
        },
        rcs: {
            key: "rcsRevenueByMonth",
            fn: getRcsRevenueByMonth,
        },
        email: {
            key: "eRevenueByMonth",
            fn: getEmailRevenueByMonth,
        },
    };
    var selected = config[ch];
    if (!selected) {
        log("Unknown Channel: ".concat(channel));
    }
    return useDashboardQuery((_a = selected === null || selected === void 0 ? void 0 : selected.key) !== null && _a !== void 0 ? _a : "unknownRevenueByMonth", (_b = selected === null || selected === void 0 ? void 0 : selected.fn) !== null && _b !== void 0 ? _b : (function () { return Promise.resolve(null); }), arg, {
        enabled: !!selected,
        refetchOnWindowFocus: false,
    });
};
/**
 * Hook to get email metrics
 * @param {DashboardHookArgs} arg
 */
export var useEmailMetricsData = function (arg) {
    return useDashboardQuery("emailMetricsData", getEmailMetrics, arg);
};
/**
 * Hook to get whatsapp account business number counter
 * @param {DashboardHookArgs} arg
 */
export var useWaABusinessNumCounter = function (arg) {
    return useDashboardQuery("WaABusinessNumCounter", getWAABusinessNumCounter, arg);
};
/**
 * Hook to get whatsapp account template analytics data
 * @param {DashboardHookArgs} arg
 */
export var useWaATemplateAnalyticsApi = function (arg) {
    return useDashboardQuery("WAATemplateAnalyticsRes", getWAATemplateAnalyticsApi, arg);
};
/**
 * Hook to get whatsapp template distribution data
 * @param {DashboardHookArgs} arg
 */
export var useWaTemplateDistribution = function (arg) {
    return useDashboardQuery("WaTemplateDistribution", getTemplateDistribution, arg);
};
/**
 * Hook to get whatsapp template types data
 * @param {DashboardHookArgs} arg
 */
export var useWaTemplateTypes = function (arg) {
    return useDashboardQuery("WaTemplateTypes", getWhatsAppTemplateTypes, arg);
};
export var useRCSMessageTypes = function (arg) {
    return useDashboardQuery("RCSMessageTypes", getAllRcsMessageType, arg);
};
/**
 * Hook to get whatsapp revenue | usage trend data
 * @param {DashboardHookArgs} arg
 */
export var useWhatsAppRevenueTrend = function (arg) {
    return useDashboardQuery("getWhatsAppRevenueTrend", getWhatsAppRevenueTrend, arg);
};
/**
 * Hook to get whatsapp message trend data
 * @param {DashboardHookArgs} arg
 */
export var useWhatsAppMessageTrend = function (arg) {
    return useDashboardQuery("getWhatsAppMessageTrend", getWhatsAppStatusTrend, arg);
};
